import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
    NICHE_PICKER_OTHER,
    NICHE_PICKER_PRIMARY,
    NICHE_PICKER_PROFESSIONAL_OPTIONS,
} from "../../constants/nichePickerOptions";
import { selectShowNichePicker, setActiveNiche } from "../../store/nicheSlice";
import { trackCtaClicked } from "../../analytics/analytics";
import { nicheCtaId } from "../../analytics/analytics.constants";
import "bootstrap-icons/font/bootstrap-icons.css";

const pillClassName =
    "inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900";

export function NichePickerContent({ onSelect = null, className = "" }) {
    const dispatch = useDispatch();

    const handleNicheClick = (nicheId) => {
        trackCtaClicked(nicheCtaId(nicheId));
        dispatch(setActiveNiche(nicheId));
        onSelect?.(nicheId);
    };

    return (
        <div className={className}>
            <h2
                id="niche-picker-title"
                className="text-base font-semibold tracking-tight text-[#021645] sm:text-lg"
            >
                What describes your business best?
            </h2>
            <p className="mt-1 text-sm text-slate-600">
                Pick your industry to see tailored marketing trends and content ideas.
            </p>

            <div className="mt-4 flex flex-wrap gap-2">
                {NICHE_PICKER_PRIMARY.map(({ id, label, icon, path }) => (
                    <Link
                        key={id}
                        to={path}
                        onClick={() => handleNicheClick(id)}
                        className={pillClassName}
                    >
                        <i className={`bi ${icon} text-slate-500`} aria-hidden />
                        {label}
                    </Link>
                ))}

                {NICHE_PICKER_PROFESSIONAL_OPTIONS.map(({ nicheId, label, icon, path }) => (
                    <Link
                        key={label}
                        to={path}
                        onClick={() => handleNicheClick(nicheId)}
                        className={pillClassName}
                    >
                        <i className={`bi ${icon} text-slate-500`} aria-hidden />
                        {label}
                    </Link>
                ))}

                <Link
                    to={NICHE_PICKER_OTHER.path}
                    onClick={() => handleNicheClick(NICHE_PICKER_OTHER.nicheId)}
                    className={pillClassName}
                >
                    <i className={`bi ${NICHE_PICKER_OTHER.icon} text-slate-500`} aria-hidden />
                    {NICHE_PICKER_OTHER.label}
                </Link>
            </div>
        </div>
    );
}

export default function NichePicker() {
    const isGuest = !useSelector((state) => state.auth.user);
    const showPicker = useSelector(selectShowNichePicker);

    if (!isGuest || !showPicker) return null;

    return (
        <section
            aria-labelledby="niche-picker-title"
            className="surface-card -mx-2 mb-6 px-4 py-5 sm:mx-0 sm:px-6"
        >
            <NichePickerContent />
        </section>
    );
}
